import { showSuccessToast } from './CommonServices/alertServices'
import { getAll, getOne, post, patch, postWithResponse, deleteOne } from './CommonServices/httpService'
import { SurveyDetails, SurveyFilters, SurveyResponse, UpsertChangeOrderRequest } from '../types/Work/Survey'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { RequestWorker } from '../types/Work/Request'
import { AttachmentsUploadResponse } from '../types/Upload/AttachmentResponse'
import { uploadImages } from './CommonServices/imageAttachmentService'

dayjs.extend(utc)

export const createQuantitySurvey = async (workItemIds: number[]) => {
	const response = await post(`/Surveys`, workItemIds)
	if (response.success) {
		showSuccessToast('Quantity surveys created successfully', true)
	}
}

export const getQuantitySurveys = async (filters: SurveyFilters) => {
	const queryParams = new URLSearchParams()
	if (filters.page) queryParams.append('page', filters.page.toString())
	if (filters.status) queryParams.append('status', filters.status)
	if (filters.assignedToId) queryParams.append('assignedToId', filters.assignedToId.toString())
	if (filters.assignedOn) queryParams.append('assignedOn', dayjs(filters.assignedOn).utc().toISOString())
	if (filters.searchWorkItem) queryParams.append('searchWorkItem', filters.searchWorkItem)
	if (filters.surveyId) queryParams.append('surveyId', filters.surveyId.toString())
	if (filters.requestedOn) queryParams.append('requestedOn', dayjs(filters.requestedOn).utc().toISOString())
	if (filters.viewMode) queryParams.append('viewMode', filters.viewMode)
	if (filters.surveyedOn) queryParams.append('surveyedOn', dayjs(filters.surveyedOn).utc().toISOString())
	const queryString = queryParams.toString()
	const url = `/Surveys${queryString ? `?${queryString}` : ''}`
	
	const response = await getAll<SurveyResponse>(url)
	return response.data
}

export const getSurveyAssignees = async () => {
	const response = await getAll<RequestWorker[]>('/Surveys/Assignees')
	return response.data
}

export const getSurveyDetails = async (surveyId: number) => {
	const response = await getOne<SurveyDetails>(`/Surveys/${surveyId}`)
	return response.data
}

export const getMissingWorkItems = async (surveyId: number) => {
	const response = await getOne<{
		workItemType: string
		splittedRequests: number
		workItemName: string
	} | null>(`/Surveys/${surveyId}/Missing`)
	return response.data
}

export const assignSurveys = async (surveyIds: number[], assigneeId: number) => {
	const response = await patch(`/Surveys/Assign/${assigneeId}`, surveyIds)
}

export const createChangeOrder = async (request: UpsertChangeOrderRequest, blobs?: Blob[]) => {
	const response = await postWithResponse<AttachmentsUploadResponse[]>(`/Surveys/ChangeOrder`, request)
	if(blobs && response.data) {
		await uploadImages(response.data, blobs)
	}
	return response.data
}

export const getChangeOrderAttachments = async (changeOrderId: number) => {
	const response = await getAll<AttachmentsUploadResponse[]>(`/Surveys/ChangeOrder/${changeOrderId}/Attachments`)
	return response.data
}

export const deleteChangeOrderAttachment = async (changeOrderId: number, attachmentId: number) => {
	await deleteOne(`/Surveys/ChangeOrder/${changeOrderId}/Attachments/${attachmentId}`)
}

export const completeSurvey = async (surveyId: number, surveyComment?: string, isMoreInfoRequired?: boolean) => {
	await patch(`/Surveys/${surveyId}/Complete${isMoreInfoRequired ? '?isMoreInfoRequired=true' : ''}`, { surveyComment })
	showSuccessToast('Survey completed successfully', true)
}

